/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { Filter } from './filtersMeta';
import { FilterPresenterType } from '../components/presenters/types';

const numberFilters: Filter[] = [
  Filter.Equals,
  Filter.IsNotEqual,
  Filter.LessThan,
  Filter.LessThanOrEquals,
  Filter.GreaterThan,
  Filter.GreaterThanOrEquals,
];
const dateFilters: Filter[] = [
  Filter.Equals,
  Filter.LessThan,
  Filter.LessThanOrEquals,
  Filter.GreaterThan,
  Filter.GreaterThanOrEquals,
];
const mappingsFilters: Filter[] = [Filter.Equals, Filter.HasMappedObjects, Filter.DoesNotHaveMappedObjects];

export const filterPresenterMeta: { [key in FilterPresenterType]: Filter[] } = {
  [FilterPresenterType.Boolean]: [Filter.Equals, Filter.IsNotEqual, Filter.IsEmpty, Filter.IsNotEmpty],
  [FilterPresenterType.Date]: dateFilters,
  [FilterPresenterType.DateTime]: dateFilters,
  [FilterPresenterType.DecimalNumber]: numberFilters,
  [FilterPresenterType.Dropdown]: [Filter.Equals, Filter.IsEmpty, Filter.IsNotEmpty],
  [FilterPresenterType.Groups]: [Filter.Equals],
  [FilterPresenterType.Number]: numberFilters,
  [FilterPresenterType.MappedObjects]: mappingsFilters,
  [FilterPresenterType.Object]: [Filter.Equals],
  [FilterPresenterType.People]: [Filter.Equals],
  [FilterPresenterType.Recurrence]: [Filter.Equals],
  [FilterPresenterType.Tags]: [Filter.Contains],
  [FilterPresenterType.Text]: [
    Filter.Contains,
    Filter.DoesNotContain,
    Filter.Equals,
    Filter.IsNotEqual,
    Filter.IsEmpty,
    Filter.IsNotEmpty,
  ],
};
